export const formatPhone = (value) => {
    const cleaned = ('' + value).replace(/\D/g, '');
    if (cleaned.length > 11) return cleaned.substring(0, 11);
    return cleaned.length <= 10
      ? cleaned.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').trim()
      : cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3').trim();
  };